export const preventDefault = (f) => (e) => {
    e.preventDefault()
    if(f) f(e)
}

export const stopPropagation = (f) => (e) => {
    e.stopPropagation()
    if(f) f(e)
}
